export enum Market {
  FR = 'hoistfinance.fr',
  DE = 'hoistfinance.de',
  ES = 'hoistfinance.es',
  PL = 'hoistfinance.pl',
  IT = 'hoistfinance.it',
  GR = 'hoistfinance.gr',
  NL = 'hoistfinance.nl',
  BE = 'hoistfinance.be',
}